module.exports = __webpack_public_path__ + "img/line-red.954b705a.svg";